<template>
  <div class="registraton">
    <div class="authorization-category">
      <div class="authorizationTitle" v-if="active !== 1 && active !== 5">
        <div class="logIn-category">
          <router-link
            :to="
              $authI18nRoute({
                name: 'LogIn',
              })
            "
            class="logIn-category-btn"
          >
            {{ $t("authorization.enter") }}
            <div class="border"></div>
          </router-link>
        </div>
        <div class="mdborder"></div>
        <div class="logIn-category">
          <router-link
            :to="
              $authI18nRoute({
                name: 'Registration',
              })
            "
            class="logIn-category-btn"
            >{{ $t("authorization.registration") }}
            <div class="border"></div>
          </router-link>
        </div>
      </div>
      <div v-if="active === 5" class="completeRegisterTitle">
        <h1>{{ $t("authorization.completeRegister") }}</h1>
        <div class="border1"></div>
      </div>
      <div v-if="active === 1" class="verifyPhone">
        <h1>Подтвердите номер телефона</h1>
        <div class="border"></div>
      </div>
    </div>
    <div class="registration-content">
      <component
        :is="`step${active}`"
        @submitForm="
          (index = 1) => {
            active += index;
          }
        "
        @goBack="active--"
      />
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import FinalMessage from "./registration/FinalMessage";
import HumanPassport from "./registration/HumanPassport";
import LoginPassword from "./registration/LoginPassword";
import Passport from "./registration/Passport";
import PersonalInfo from "./registration/PersonalInfo";
import VerifyPhone from "./registration/VerifyPhone";

export default {
  components: {
    step0: PersonalInfo,
    step1: VerifyPhone,
    step2: LoginPassword,
    step3: Passport,
    step4: HumanPassport,
    step5: FinalMessage,
  },
  setup() {
    const active = ref(0);
    return { active };
  },
};
</script>

<style lang="scss" scoped>
.registraton {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40rem;
  height: max-content;
  .authorization-category {
    display: flex;
    justify-content: space-around;
    width: 100%;
    .authorizationTitle {
      display: flex;
      justify-content: space-around;
      width: 100%;
      .logIn-category {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .logIn-category-btn {
          font-size: 1.875em;
          font-weight: 400;
          line-height: 2.198em;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          // margin-top: 1.188rem;
          color: rgba(93, 93, 93, 1);
          background: transparent;
          outline: none;
          cursor: pointer;

          &:hover,
          &.router-link-exact-active {
            .border {
              background: rgba(29, 82, 149, 1);
              height: 0.313rem;
              transition: all 0.5s;
            }
          }
        }
      }
      .border {
        width: 100%;
        height: 1px;
        background: rgba(230, 230, 230, 1);
        // margin-top: 1.125rem;
      }
      .mdborder {
        width: 1px;
        height: 2.625rem;
        background: #e6e6e6;
        margin-top: 0.938rem;
      }
    }
    .completeRegisterTitle {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        font-size: 1.875em;
        line-height: 2.198em;
        color: rgba(93, 93, 93, 1);
      }
      .border1 {
        width: 90%;
        height: 0.313rem;
        background: rgba(29, 82, 149, 1);
        cursor: pointer;
      }
    }
    .verifyPhone {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      h1 {
        font-size: 1.875em;
        line-height: 0.9em;
        color: rgba(93, 93, 93, 1);
        margin-top: 1.1rem;
      }
      .border {
        width: 90%;
        background: rgba(29, 82, 149, 1);
        height: 0.313rem;
        margin-top: 1.1rem;
      }
    }
  }
  .registration-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 40rem;
  }
}

@media screen and (max-width: 1366px) {
  .registraton {
    width: 33rem;
    .authorization-category {
      width: 100%;
      .authorizationTitle {
        width: 100%;
        .logIn-category {
          width: 100%;
          .logIn-category-btn {
            font-size: 1.625em;
            line-height: 1.904em;
            font-weight: 400;
          }
        }
      }
    }
    .registration-content {
      width: 33rem;
    }
  }
}
@media screen and (max-width: 540px) {
  .registraton {
    width: 20.938rem;

    .authorization-category {
      width: 100%;
      .authorizationTitle {
        width: 100%;
        .logIn-category {
          width: 100%;
          .logIn-category-btn {
            font-size: 1.325em;
            line-height: 1.904em;
            font-weight: 400;
          }
        }
      }
      .completeRegisterTitle {
        h1 {
          font-size: 1.325em;
        }
      }
    }
    .registration-content {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
